<template>
  <div class="playApp" :style="'min-height:'+curHeight+'px'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <videoPlayer class="video-player vjs-custom-skin" ref="videoPlayer" :playsinline="true" :options="playerOptions"></videoPlayer>
  </div>
</template>
 
<script>
  import { videoPlayer } from 'vue-video-player'
  import '../../assets/video.js/dist/video-js.css'
  export default {
    data() {
      return {
        playerOptions: {
           playbackRates: [0.5, 1.0, 1.5, 2.0], // 可选的播放速度
           autoplay: true, // 如果为true,浏览器准备好时开始回放。
           muted: false, // 默认情况下将会消除任何音频。
           loop: false, // 是否视频一结束就重新开始。
           preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
           language: 'zh-CN',
           aspectRatio: '9:16', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
           fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
           sources: [{
            type: "video/mp4", // 类型
            src: 'https://285-cn-east-2.cdn-vod.huaweicloud.com/asset/acc0e442d88db84a1191f0273875b4b1/91fd4ecae885fadaaef3870ba013b006.mp4' // url地址
           }],
           poster: 'https://aligw.laife.cn/upload/20201023/0d65cb6f1448e130ed9298df946eae9c.jpg', // 封面地址
           notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
           controlBar: {
              timeDivider: true, // 当前时间和持续时间的分隔符
              durationDisplay: false, // 显示持续时间
              remainingTimeDisplay: true, // 是否显示剩余时间功能
              fullscreenToggle: true // 是否显示全屏按钮
           }
        },
        curHeight:0,
        fullscreenLoading: false,
      };
    },
    beforeMount() {
      var id = this.$route.query.id;
      var url = 'https://aligw.laife.cn/share/'+id+'.mp4';
      this.playerOptions.sources[0].src = url
      this.playerOptions.poster = require( '../../assets/images/'+id+'.jpg')
    },
    mounted() {
      this.beforeMount();
    },
    // 播放回调
    onPlayerPlay(player) {
    },
    // 视频播完回调
    onPlayerEnded($event) {
    },
    // 当前播放位置发生变化时触发。
    onPlayerTimeupdate($event) {
    },

    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      }
    },
    components: {
      videoPlayer
    }
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .playApp{
    max-width:640px;
    background:#000;
    margin:0 auto;
  }

  .playApp .video-js .vjs-big-play-button {
    left:50%;
    top:50%;
    transform: translate(-50%,-50%);
    outline: none!importrant;
  }
 
</style>